module.exports = __webpack_public_path__ + "img/8fb40dd.svg";